const LicensePaths = {
    // users
    ADMIN: "users.admin",
    MANAGER: "users.manager",
    OPERATOR: "users.operator",
    TV: "users.tv",
    SOLIDTASK: "users.solidtask",
    SUPPORT: "users.support",

    // breeding
    BREEDING_SOW: "breeding.sow",
    BREEDING_PORKER: "breeding.porker",

    // utilities
    SOLIDMAP: "utilities.solidmap",
    FILES: "utilities.files",
    ANALYSIS: "utilities.analysis",
    AI: "utilities.ai",

    // devices
    NUTRI_ONE: "devices.NutriOne.active",
    NUTRI_ONE_MATING: "devices.NutriOneMating.active",
    NUTRI_GROUP: "devices.NutriGroup.active",
    NUTRI_PRO: "devices.NutriPro.active",
    NUTRI_SORT: "devices.NutriSort.active", // klatki sortujące
    MICROCLIMATE: "devices.Microclimate.active", // sterowanie mikroklimatem
    SILOMASS: "devices.Silomass.active", // pomiar masy w silosie
    METRIS: "devices.Metris.active", // liczniki pradu i wody
    IPSUM: "devices.IPSUM.active",
    LIGHTS: "devices.Lights.active",
    CHAIN_FEEDER: "devices.ChainFeeder.active",
    RAMP_SCALE: "devices.RampScale.active", // waga najazdowa
    CCTV: "devices.CCTV.active", // monitoring wideo
    FARM_WATCH_PRO: "devices.FarmWatchPRO.active",
};

export default LicensePaths;
